var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  举报前台_举报注册\n  ")])}
var staticRenderFns = []

export { render, staticRenderFns }